import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import FerramentasRepository from '@/shared/http/repositories/business/tools'
// import aprTemplateEpiRepository from '@/shared/http/repositories/business/aprTemplateEpi'

// import Tools from '@/components/tools/Tools'

export default {
  name: 'addEpiApr',
  props: ['aprId', 'revisao'],
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      Adicionar: true,
      searchEpi: null,
      cancelarFerramentas: false,
      dataFerramentas: [],
      datanewFerramentas: {},
      dataFiltroFerramentas: [],
      buscaFerramentas: '',
      FerramentaAguardandoEnvio: []
    }
  },

  watch: {
    buscaFerramentas (newvalue, oldvalue) {
      if (newvalue.trim() !== '') {
        this.BuscaFerramentasAdd(newvalue)
      } else {
        this.dataFiltroFerramentas = this.dataFerramentas
      }
    }
  },

  mounted () {
  },
  methods: {
    AdicionarFerramentas (id) {
      let novaFerramenta = {descricao: id.descricao, statusAprovacaoDescricao: 'AG. ENVIO', statusAprovacao: null, dateCricaoFormatada: null, dateCricao: null, ferramentaId: id.id, tipoMudanca: 'INCLUSÃO AG. ENVIO', AgEnvio: true}
      this.FerramentaAguardandoEnvio.push(novaFerramenta)
      this.Adicionar = !this.Adicionar
      var div = document.getElementById(id.id)
      // Verifica se a classe 'clicked' já está presente na div
      var isClicked = div.classList.contains('clicked')
      // Se já estiver clicada, remove a classe, caso contrário, adiciona
      if (isClicked) {
        div.classList.remove('clicked')
        this.FerramentaAguardandoEnvio = this.FerramentaAguardandoEnvio.filter(epi => epi.ferramentaId !== id.id)
      } else {
        div.classList.add('clicked')
      }
    },
    identificarElementosClicados () {
      var elementosClicados = []
      this.dataFerramentas.forEach(function (elemento) {
        var elementoHTML = document.getElementById(elemento.id)
        if (elementoHTML && elementoHTML.classList.contains('clicked')) {
          elementosClicados.push(elementoHTML.id)
        }
      })
      if (elementosClicados.length > 0) {
        this.addEPI(elementosClicados)
      } else {
        toast.warning('Adicione pelo menos um item')
      }
    },
    cancel () {
      this.cancelarFerramentas = !this.cancelarFerramentas
      this.$emit('cancelarFerramentas', this.cancelarFerramentas)
    },
    addEPI (ids) {
      console.log(ids)
      this.datanewFerramentas = {ferramentas: ids, APRId: this.aprId}
      this.$emit('salvarFerramentas', this.datanewFerramentas)
      this.$emit('AdicionarTableFerramentas', this.FerramentaAguardandoEnvio)
    },
    onLoad () {
      loading.push()
      FerramentasRepository.GetFerramentasFiltros(this.aprId, this.revisao)
        .then((Response) => {
          loading.pop()
          this.dataFerramentas = Response.data.data
          this.dataFiltroFerramentas = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    BuscaFerramentasAdd (value) {
      this.dataFiltroFerramentas = this.dataFerramentas.filter((Element) => Element.descricao.toUpperCase().indexOf(value.toUpperCase()) > -1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/addToolsApr/addToolsApr.js